import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

/**
 * The "Have you used contraception?" answer lives on
 * `obGynHistory.hasContraceptionHistory` for every patient: the backend has no
 * male-history field for it, and the save writes it there for AMAB patients
 * too (verified round trip in dashboard-api's medical-history audit). Reading
 * a male-history field instead left a man's "No" at 0% forever.
 */
export function calculateContraceptionCompletion(
  patient: Patient | null | undefined,
) {
  const isMale = patient?.gender === "AMAB";
  const answered = patient?.obGynHistory?.hasContraceptionHistory != null;

  const hasAnswered = isMale
    ? answered || (patient?.maleHistory?.contraceptions ?? []).length > 0
    : answered;

  const fields = [hasAnswered];

  const completed = fields.filter(Boolean).length;
  const total = fields.length;

  return {
    percent: total > 0 ? completed / total : 0,
    label: `${completed}/${total} answered`,
    completed,
    total,
  };
}
